import { motion } from "framer-motion";
import { FAQS } from "../data";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export const FAQ = () => {
  return (
    <section id="faq" className="relative mx-auto max-w-3xl scroll-mt-24 px-5 py-24 md:px-8 md:py-32">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-12 text-center"
      >
        <span className="text-sm font-bold uppercase tracking-[0.25em] text-[#3B82F6]">Du hast Fragen?</span>
        <h2 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-white md:text-5xl">
          Häufige <span className="gradient-text">Fragen</span>
        </h2>
      </motion.div>

      <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            data-testid={`faq-${i}`}
            className="overflow-hidden rounded-2xl border border-white/10 bg-[#0B111E] px-6"
          >
            <AccordionTrigger className="py-5 text-left font-heading text-base font-bold text-white hover:text-[#60A5FA] hover:no-underline md:text-lg">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-5 text-[15px] leading-relaxed text-gray-400">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
